export const meses = [
    { value: "01", label: "Janeiro" },
    { value: "02", label: "Fevereiro" },
    { value: "03", label: "Março" },
    { value: "04", label: "Abril" },
    { value: "05", label: "Maio" },
    { value: "06", label: "Junho" },
    { value: "07", label: "Julho" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Setembro" },
    { value: "10", label: "Outubro" },
    { value: "11", label: "Novembro" },
    { value: "12", label: "Dezembro" },
];

export const hoje = new Date();
export const mesAtual = String(hoje.getMonth() + 1).padStart(2, "0");
export const anoAtual = String(hoje.getFullYear());
const anoAtualN = hoje.getFullYear();
export const anoAnterior = anoAtualN - 1;

export function formatMoney(value: string | number) {
    return (value ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function formatPercent(value: string | number) {
    return (value ?? 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "%";
}

export function formatInt(value: string | number) {
    return (value ?? 0).toLocaleString("pt-BR");
}